import { Link } from 'react-router-dom';
import { gossipItems, channelLabel } from '@/mocks/gossip';
import { formatViews } from '@/components/feature/NewsCard';

const top = [...gossipItems].sort((a, b) => b.views - a.views).slice(0, 6);

export default function HotRank() {
  return (
    <div className="rounded-xl border border-background-200 bg-background-50 p-5 md:p-6">
      <div className="flex items-center justify-between">
        <h3 className="flex items-center gap-2 font-heading text-lg font-black text-foreground-900">
          <span className="grid h-7 w-7 items-center justify-center rounded-full bg-accent-500 text-sm text-background-50">
            <i className="ri-fire-line"></i>
          </span>
          本周热议
        </h3>
        <Link to="/daily" className="text-xs font-bold text-primary-600 hover:text-primary-800">全部合集</Link>
      </div>
      <ol className="mt-4 space-y-1">
        {top.map((item, i) => (
          <li key={item.slug}>
            <Link
              to={`/news/${item.slug}`}
              className="group flex items-start gap-3 rounded-lg px-2 py-2.5 transition-colors hover:bg-background-100"
            >
              <span
                className={`mt-0.5 w-6 shrink-0 text-center font-heading text-lg font-black leading-none ${
                  i < 3 ? 'text-accent-600' : 'text-background-400'
                }`}
              >
                {i + 1}
              </span>
              <div className="min-w-0 flex-1">
                <h4 className="line-clamp-2 text-sm font-bold leading-snug text-foreground-800 group-hover:text-primary-700">
                  {item.title}
                </h4>
                <p className="mt-1 text-xs text-foreground-400">
                  {channelLabel(item.channel)} · {formatViews(item.views)} 热度
                </p>
              </div>
            </Link>
          </li>
        ))}
      </ol>
    </div>
  );
}